module.exports = "<div class=\"<%= gwTileContentInside %>\" gw-partial=\"Item\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/Content/TileContent.html
// module id = 599
// module chunks = 0